export const ANSWERS_DATA = {
  tutorialQuiz1: {
    answer: "삼성전자",

    next: {
      route: "/answer",
      DateVal: "tutorialQuiz1_answer",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  quiz1: {
    answer: "2",

    next: {
      route: "/answer",
      DateVal: "quiz1_answer",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  quiz2: {
    answer: "3",

    next: {
      route: "/answer",
      DateVal: "quiz2_answer",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  quiz3: {
    answer: "4",

    next: {
      route: "/answer",
      DateVal: "quiz3_answer",
      titImgClass: "answerTit",
      counting: true,
    },
  },
};
